<div class=" import-wrapper p-7 white-bg " [formGroup]="rulevarservice.intelForm" [ngClass]="inputShow ? 'hide':''">
    <div class="populate-values p-3" formGroupName="createTable">
        <ng-container *ngIf="data == 'import'">
            <h4 class="bold-text primary-text">Import CSV/XLSX</h4>
        </ng-container>
        <ng-container *ngIf="data == 'manual'">
            <h4 class="bold-text primary-text">Import manually</h4>
        </ng-container>
        <div class="modes hide">
            <ng-container *ngFor="let name of rulevarservice.entryModes">
                <div class="options">
                    <input type="radio" formControlName="entryMode" [value]="name">
                    <p class="primary-text content-m">{{name}}</p>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="import-body">
    <ng-container *ngIf="entryMode.value === 'import'">
        <div class="import-wrapper pt-0 white-bg px-3" formGroupName="createTable">
           
            <div class="file-wrapper hide">
                <input #uploadFile class="input-border choose-file" (click)="openFileDialog($event)"  type="file" accept=".xlsx, .xls, .csv" />
                <!-- <button  (click)="openUpload($event)"></button> -->
            </div>
            <ng-template #Popup let-dialogRef="dialogRef">
                <!-- <h5 class="primary-text" mat-dialog-title>Do you want to delete rows above {{maxEntry.value}} ?</h5> -->
              
                <mat-dialog-content>
                    <p class="content-l primary-text m-7">Please upload a file smaller than {{rulevarservice.importSizeLimit/1024/1024}} MB.</p>
                </mat-dialog-content>
              
                <mat-dialog-actions align="end">
                    <button mat-button class="submit" (click)="popupYes()">OK</button>
                  
                </mat-dialog-actions>
            </ng-template>
            <ng-template #MaxRowPopup let-dialogRef="dialogRef">
                <!-- <h5 class="primary-text" mat-dialog-title>Do you want to delete rows above {{maxEntry.value}} ?</h5> -->
              
                <mat-dialog-content>
                    <p class="content-l primary-text m-7">The list size exceeds the limit. Would you like to insert only the first {{rulevarservice.importDetail?.max_entry-rulevarservice.importDetail?.total_rows}} rows?</p>
                </mat-dialog-content>
              
                <mat-dialog-actions align="end">
                    <button mat-button class="submit" (click)="MaxRowPopupYes()">YES</button>
                    <button mat-button class="cancel" (click)="MaxRowPopupNo()">NO</button>
                  
                </mat-dialog-actions>
            </ng-template>

            <ng-template #confirmHeader let-dialogRef="dialogRef">
                <!-- <h5 class="primary-text" mat-dialog-title>Do you want to delete rows above {{maxEntry.value}} ?</h5> -->
              
                <mat-dialog-content>
                    <p class="content-l primary-text m-7">Please upload a file smaller than {{rulevarservice.importSizeLimit/1024/1024}} MB.</p>
                </mat-dialog-content>
              
                <mat-dialog-actions align="end">
                    <button mat-button class="submit" >OK</button>
                  
                </mat-dialog-actions>
            </ng-template>
        
            <div class="mapping-area" formArrayName="table">
                <ng-container *ngIf="rawData">
                    <div class="sample-data">
                        <div class="sample-header">
                            <div class="fileName">
                                <p class="content-m primary-text">File name : </p>
                                <p class="content-m primary-text bold-text">{{filename}}</p>
                            </div>
                            <p class="primary-text content-m bold-text pr-2">Showing 10 of {{rawData.length}} Rows</p>
                        </div>
                        <div class="table">
                            <table>
                                <thead>
                                    <tr>
                                        <ng-container *ngIf="rawData.length">
                                            <ng-container *ngFor="let head of rawData[0] | keyvalue: originalOrder">
                                                <th>{{head.key}}</th>
                                            </ng-container>
                                        </ng-container>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let head of rawData | slice:0:10">
                                        <ng-container *ngFor="let data of head | keyvalue: originalOrder">
                                            <td [tooltip]="data.value">{{data.value}}</td>
                                        </ng-container>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="rawData">
                    <div class="mapping-table">
                        <div class="map-wrapper">
                            <h4 class="bold-text primary-text">Mapping Fields</h4>
                            <div class="mapping-Titles mt-2">
                                <p class="primary-text content-l bold-text ">Intel List Fields</p>
                                <p class="primary-text content-l bold-text">Imported Fields</p>
                            </div>
                            <div class="columns">
                                <ng-container *ngIf="rawData">
                                    <ng-container *ngFor="let field of table.controls ; index as i">

                                        <ng-container *ngIf="!field.get('enrichable').value">
                                            <div class="mapping-rows" [formGroupName]="i">
                                                <ng-container *ngIf="field.get('enrichable').value != true">
                                                    <p class="primary-text content-m createdFields">{{field.get('fieldName').value}}</p>
                                                    <p class="primary-text bold-text content-m equals">=</p>
                                                    <div class="inputNerror">
                                                        <app-overlay-select [data]="rulevarservice.importedFields" [formControl]="field.get('mappedField')"></app-overlay-select>
                                                        <div class="dataTypeError">
                                                            <ng-container *ngFor="let data of rulevarservice.dataTypeError">
                                                                <ng-container *ngIf="data === field.get('fieldName').value">
                                                                    <p class="alert-text content-s">{{rulevarservice.dataTypeErrorString}}</p>
                                                                </ng-container>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <!-- <div class="headers">
                                <ng-container *ngIf="rawData">
                                    <ng-container *ngFor="let head of rawData[0] | keyvalue: originalOrder">
                                        <p class="primary-text content-m">{{head.key}}</p>
                                    </ng-container>
                                </ng-container>
                            </div> -->
                        </div>
                        <div class="import-error">
                            <ng-container *ngIf="rulevarservice.importIntelError === true">
                                <p class="alert-text content-s">{{importErrorString}}</p>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="entryMode.value === 'manual'">
        <div class="manual-wrapper white-bg p-3" [formGroup]="rulevarservice.manualIntel">
            <!-- <div class="manual-table" [style.--cols]="table.controls.length" [style.--rows]="table.controls.length"> -->
            <div class="manual-table" formArrayName="manualTable">
                <!-- <ng-container *ngFor="let head of table.controls">
                    <div class="heads">
                        <p class="content-m bold-text primary-text">{{head.get('fieldName').value}}</p>
                    </div>
                </ng-container> -->
                <table>
                    <thead>
                        <tr>
                            <td class="s-no pl-2">S.No</td>
                            <ng-container *ngFor="let head of rulevarservice.importTable">
                                <ng-container *ngIf="!head.enrichable">
                                    <td>{{head.fieldName}}</td>
                                </ng-container>
                            </ng-container>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let head of manualTable.controls ; index as i">
                            <tr [formGroupName]="i">
                                <td class="border-light pl-2 s-no">{{i+1}}</td>
                                <ng-container *ngFor="let form of rulevarservice.importTable; index as j">
                                    <ng-container *ngIf="form.enrichable != true">
                                        
                                        <td (keydown.enter)="addManualClick(i,'keydown')">
                                            <ng-container *ngIf="form.fieldName && form.dataType">
                                                <ng-container *ngIf="form.dataType === 'text'">
                                                    <input type="text" [formControlName]="form.fieldName">
                                                </ng-container>
                                                <ng-container *ngIf="form.dataType === 'number'">
                                                    <input type="number" [formControlName]="form.fieldName">
                                                </ng-container>
                                                <ng-container *ngIf="form.dataType === 'inet'">
                                                    <input
                                                    type="text"
                                                    minlength="7"
                                                    maxlength="15"
                                                    size="15"
                                                    pattern="^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$"
                                                    [formControlName]="form.fieldName"
                                                    />
                                                </ng-container>
                                                
                                                <!-- <input [type]="form.get('dataType')?.value" [formControlName]="addControls()"> -->

                                            </ng-container>
                                        </td>
                                    </ng-container>
                                </ng-container>
                                <img src="../../../../assets/rule/delete.svg" (click)="removeManualClick(i)" tooltip="Delete" class="enable-action delete-row icon-s tooltip-enable pl-2">
                                <ng-container *ngIf="i === manualTable.controls.length-1">
                                    <img src="../../../../assets/rule/plus.svg" (click)="addManualClick(i)" tooltip="Add"  class="enable-action icon-s tooltip-enable pl-2">
                                </ng-container>
                            </tr>
                        </ng-container>
                        
                    </tbody>
                </table>
                <div class="manual-error">
                    <ng-container *ngIf="rulevarservice.manualIntelError === true">
                        <p class="alert-text content-s">{{rulevarservice.manualErrorString}}</p>
                    </ng-container>
                </div>
                
            </div>
        </div>
    </ng-container>
    </div>
    <div class="buttons">
        <button class="submit" (click)="nextClick()">SUBMIT</button>
        <button class="cancel" (click)="previousClick()">CANCEL</button>
    </div>
</div>
